import { useEffect } from "react";

import { installLanguageBridge } from "../services/language-bridge";
import { setLanguage } from "../services/i18n";

/**
 * Keeps the widget's language in sync with the host page for the lifetime of
 * the app. The initial language comes from the URL at boot (see i18n.ts); this
 * handles later changes the host pushes over postMessage.
 */
export function useLanguageSync(): void {
  useEffect(() => installLanguageBridge({ onLanguage: setLanguage }), []);
}
